import { render, staticRenderFns } from "./FormSignup.vue?vue&type=template&id=16c897a7&"
import script from "./FormSignup.vue?vue&type=script&lang=js&"
export * from "./FormSignup.vue?vue&type=script&lang=js&"
import style0 from "./FormSignup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports